import { CreateQuoteFormValues } from '../types';
import { CreateQuoteDto } from '../../proposals';

class QuoteProposalMapper {
  public processQuoteProposalFormToCreateDto(voId: string, formData: CreateQuoteFormValues): CreateQuoteDto {
    return {
      voId,
      notesToBuyer: formData.notesToBuyer,
      notification: {
        transport: formData.notification.transport,
        emails: formData.notification.emails.map(({ value }) => value),
        ccEmails: formData.notification.ccEmails.map(({ value }) => value),
      },
    };
  }
}

export const quoteProposalMapper = new QuoteProposalMapper();
